var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1671 1.52246C21.9863 1.40009 21.7566 1.37535 21.5539 1.4564L15.4093 3.91421V2.06724C15.4093 0.927368 14.482 0 13.3421 0H2.06728C0.927412 0 0 0.927368 0 2.06724V11.9328C0 13.0726 0.927412 14 2.06728 14H13.3421C14.482 14 15.4093 13.0726 15.4093 11.9328V10.0858L21.5539 12.5436C21.6328 12.5751 21.7157 12.5907 21.7982 12.5907C21.9279 12.5907 22.0566 12.5523 22.1671 12.4775C22.3479 12.3551 22.4561 12.1511 22.4561 11.9328V2.06724C22.4561 1.84895 22.3479 1.64487 22.1671 1.52246ZM14.0936 11.9328C14.0936 12.3471 13.7564 12.6842 13.3421 12.6842H2.06728C1.65294 12.6842 1.31579 12.3471 1.31579 11.9328V2.06724C1.31579 1.65289 1.65294 1.31579 2.06728 1.31579H13.3421C13.7564 1.31579 14.0936 1.65289 14.0936 2.06724V11.9328ZM21.1404 10.9611L15.4093 8.66864V5.33136L21.1404 3.03895V10.9611Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.509bddb7dd158d078d6382a2e88db2ca.svg";
export { ForwardRef as ReactComponent };